export default {
    "roleAccounts": null,
    "companyName": null,
    "communityAccounts": null,
    "orderBy": null,
    "delFlag": "0",
    "cardNo": null,
    "orgId": null,
    "limitTime": null,
    "lastLoginTime_str": "2019-04-08 01:25:22",
    "password": "$2a$10$kjkprieqahY5R2Iq.d.OtutaNbeBJd3/b/P.Fh5KTV9Zagtl9TyEi",
    "updateBy": "1",
    "rpoHouseMap": null,
    "legalPerson": null,
    "nickname": "超级管理员",
    "sysAttachments": [],
    "id": "1",
    "state": "1",
    // "adminFlag": "1",
    "email": null,
    "rpoHouseList": null,
    "truename": "老大",
    "repairTj": null,
    "address": null,
    "projectPersonMobile": null,
    "headImg": "http://lessons.tegoc.cn/20181213/5ee6aa6f4fa04732bea32d5b89ff56a8.jpg",
    "adminType": "ADMIN",
    "oldPassword": null,
    "sex": null,
    "mobile": "15953108080",
    "resources": null,
    "communityList": null,
    "updateTime": "2019-03-05 14:13:06",
    "sort": 999,
    "createTime_str": "2019-03-05 14:13:13",
    "roleList": [{
        "id": "1",
        "createTime": "2018-10-12 03:25:59",
        "updateTime": "2018-10-12 03:25:51",
        "createBy": "333",
        "updateBy": "123",
        "state": "1",
        "sort": 999,
        "delFlag": "0",
        "ids": "",
        "orderBy": "",
        "code": "admin",
        "name": "超级管理员",
        "parentId": "0",
        "parentPath": "0,1,",
        "remark": "超管",
        "pname": "",
        "children": [],
        "resources": []
    }],
    "communityIds": null,
    "lastLoginTime_date_str": "2019-04-08",
    "lastLoginTime": "2019-04-08 01:25:22",
    "updateTime_date_str": "2019-03-05",
    "createBy": "1",
    "createTime": "2019-03-05 14:13:13",
    "updateTime_str": "2019-03-05 14:13:06",
    "ids": null,
    "position": null,
    "projectName": null,
    "createTime_date_str": "2019-03-05",
    "projectPerson": null,
    "username": "admin",
    "isPlayAudioNotification": "1"
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/sys/account/info.js